import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment.prod';
import { ContactDto } from '@models/users/contact.dto';
import { PeriodDto } from '@models/users/period.dto';
import { RequestTopic } from '@models/users/request-topic.dto';
import { UserRequest } from '@models/users/user-request.dto';
import { tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  constructor(private http: HttpClient) {}

  getContacts() {
    return this.http.get<ContactDto[]>(environment.host + '/contacts/list');
  }

  getTopicList() {
    return this.http.get<RequestTopic[]>(
      environment.host + '/contacts/topic/list',
    );
  }

  getContactView() {
    return this.http.get<ContactDto[]>(environment.host + '/contacts/view');
  }

  createContact(contacts: ContactDto[]) {
    return this.http.post<ContactDto[]>(
      environment.host + '/contacts/create',
      contacts,
    );
  }

  modifyContact(contacts: ContactDto[]) {
    return this.http.post<ContactDto[]>(
      environment.host + '/contacts/modify',
      contacts,
    );
  }

  removeContact(contacts: ContactDto[]) {
    return this.http.post<ContactDto[]>(
      environment.host + '/contacts/remove',
      contacts,
    );
  }

  getRequestList() {
    return this.http.get<UserRequest[]>(
      environment.host + '/contacts/request-list',
    );
  }

  openRequest(requests: UserRequest) {
    return this.http.post<UserRequest>(
      environment.host + '/contacts/create-request',
      requests,
    );
  }

  modifyRequest(requests: UserRequest) {
    return this.http.post<UserRequest>(
      environment.host + '/contacts/modify-request',
      requests,
    );
  }

  closeRequest(requests: UserRequest) {
    return this.http.post<UserRequest>(
      environment.host + '/contacts/close-request',
      requests,
    );
  }

  removeRequest(requests: UserRequest) {
    return this.http.post<UserRequest>(
      environment.host + '/contacts/remove-request',
      requests,
    );
  }

  updateTopic(topics: RequestTopic[]) {
    return this.http.post<RequestTopic[]>(
      environment.host + '/contacts/topic/update',
      topics,
    );
  }

  removeTopic(topics: RequestTopic[]) {
    return this.http.post<RequestTopic[]>(
      environment.host + '/contacts/topic/remove',
      topics,
    );
  }

  getAvailabilityView() {
    return this.http
      .get<PeriodDto[]>(environment.host + '/contacts/availability/view')
      .pipe(
        tap((res) => {
          for (let period of res) {
            period.startDate = new Date(period.startDate);
            period.endDate = new Date(period.endDate);

            for (let unit of period.units) {
              unit.unitDate = new Date(unit.unitDate);
            }
          }
        }),
      );
  }

  createAvailability(periods: PeriodDto[]) {
    return this.http.post<PeriodDto[]>(
      environment.host + '/contacts/availability/create',
      periods,
    );
  }

  modifyAvailability(periods: PeriodDto[]) {
    return this.http.post<PeriodDto[]>(
      environment.host + '/contacts/availability/modify',
      periods,
    );
  }

  removeAvailability(periods: PeriodDto[]) {
    return this.http.post<PeriodDto[]>(
      environment.host + '/contacts/availability/remove',
      periods,
    );
  }
}
